import PricingBadge from './PricingBadge'

const PricingCard = ({
  name,
  subtitle,
  price,
  badge,
  disabled,
  billedText,
}) => {

  return (
    <div
      className={`
        relative
        w-[282px]
        min-h-[282px]
        rounded-[12px]
        overflow-hidden
        border
        transition-all
        duration-300
        group

        ${
          disabled
            ? 'border-white/5 opacity-70'
            : 'border-[#31551B] hover:-translate-y-2 hover:shadow-[0_30px_60px_rgba(0,0,0,0.25)]'
        }
      `}
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#081403]" />

      {/* Green glow */}
      <div className="absolute inset-0 opacity-80 bg-[radial-gradient(circle_at_top_right,_rgba(76,188,24,0.65),_transparent_45%)]" />

      {/* Inner border */}
      <div className="absolute inset-0 rounded-[28px] border border-white/5" />

      {/* Badge */}
      {badge && <PricingBadge text={badge} />}

      <div className="relative z-10 p-6 flex flex-col h-full">
        {/* Header */}
        <div className='flex flex-col'>
          <h3 className="text-[24px] text-left font-bold text-white">
            {name}
          </h3>

          <p className="mt-1 text-[14px] text-left text-white/75 leading-relaxed">
            {subtitle}
          </p>
        </div>

        {/* Pricing */}
        <div className="mt-6 flex items-end gap-3">
          <span className="text-[42px] font-black text-white tracking-[-2px] leading-none">
            {price ? `$${price}` : '$ -'}
          </span>

          {price && (
            <span className="text-[20px] text-white/40 mb-[8px]">
              /month
            </span>
          )}
        </div>

        {/* Annual billing text */}
        {billedText && (
          <p className="mt-2 text-left text-[14px] text-white/60 font-medium">
            {billedText}
          </p>
        )}

        {/* CTA */}
        <div className="mt-auto pt-3">
          <button
            disabled={disabled}
            className={`
              w-[210]
              h-[56px]
              px-8
              rounded-full
              text-[14px]
              font-semibold
              transition-all
              duration-300

              ${
                disabled
                  ? 'bg-white/10 text-white/30 cursor-not-allowed'
                  : 'bg-white text-brand-dark hover:scale-[1.02] hover:bg-brand-pageFill'
              }
            `}
          >
            Start 7-Day Free Trial
          </button>
        </div>
      </div>
    </div>
  )
}

export default PricingCard